export default {
    mapLandmarkVisibleLandmarkGroups_success: "Preferences saved successfully",
    mapLandmarkVisibleLandmarkGroups_selectAll: "Select All",
    mapLandmarkVisibleLandmarkGroups_unselectAll: "Un-select All",
};